var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Validation, required, email } from "../Decorators/validation.ts";
import FormGroup from "../Components/FormGroup.vue";
import Row from "bootstrap-vue/es/components/layout/row";
import Col from "bootstrap-vue/es/components/layout/col";
var PasswordLogin = /** @class */ (function (_super) {
    __extends(PasswordLogin, _super);
    function PasswordLogin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localUsername = _this.username || null;
        _this.localPassword = _this.password || null;
        _this.localPersistent = _this.persistent;
        _this.submitClicked = false;
        _this.submitting = false;
        return _this;
    }
    PasswordLogin.prototype.onUsernameChanged = function (val) { this.$emit("update:username", val); };
    Object.defineProperty(PasswordLogin.prototype, "usernameMetadata", {
        get: function () {
            return {
                id: "username", name: "username",
                label: "Email Address", prompt: "Please enter your email address",
                validations: {
                    required: { errorMessage: "Email address is required" },
                    email: { errorMessage: "Email address is invalid" }
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    PasswordLogin.prototype.onPasswordChanged = function (val) { this.$emit("update:password", val); };
    Object.defineProperty(PasswordLogin.prototype, "passwordMetadata", {
        get: function () {
            return {
                id: "password", name: "password",
                label: "Password", prompt: "Please enter your password",
                validations: {
                    required: { errorMessage: "Password is required" }
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    PasswordLogin.prototype.onPersistentChanged = function (val) { this.$emit("update:persistent", val); };
    Object.defineProperty(PasswordLogin.prototype, "persistentMetadata", {
        get: function () {
            return {
                id: "persistent", name: "persistent",
                label: "Stay logged in?"
            };
        },
        enumerable: true,
        configurable: true
    });
    PasswordLogin.prototype.onSubmit = function (ev) {
        this.$v.$touch();
        this.submitClicked = true;
        if (this.$v.$invalid) {
            this.focusInvalid();
            ev.preventDefault();
        }
        else {
            this.submitting = true;
        }
    };
    PasswordLogin.prototype.focusInvalid = function () {
        var _this = this;
        if (!this.$refs.root)
            return;
        Vue.nextTick().then(function () {
            var firstInvalid = _this.$refs.root.querySelector(".form-control.is-invalid");
            if (!firstInvalid)
                return;
            firstInvalid.scrollIntoView(false);
            firstInvalid.focus();
        });
    };
    PasswordLogin.prototype.onKeypressEnter = function () {
        if (!this.$refs.submit)
            return;
        this.$refs.submit.click();
    };
    __decorate([
        Prop({ type: String, required: true })
    ], PasswordLogin.prototype, "formAction", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], PasswordLogin.prototype, "resetPasswordUrl", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], PasswordLogin.prototype, "small", void 0);
    __decorate([
        Prop({ type: String })
    ], PasswordLogin.prototype, "username", void 0);
    __decorate([
        Validation({ required: required, email: email })
    ], PasswordLogin.prototype, "localUsername", void 0);
    __decorate([
        Watch("localUsername")
    ], PasswordLogin.prototype, "onUsernameChanged", null);
    __decorate([
        Prop({ type: String })
    ], PasswordLogin.prototype, "password", void 0);
    __decorate([
        Validation({ required: required })
    ], PasswordLogin.prototype, "localPassword", void 0);
    __decorate([
        Watch("localPassword")
    ], PasswordLogin.prototype, "onPasswordChanged", null);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], PasswordLogin.prototype, "persistent", void 0);
    __decorate([
        Watch("localPersistent")
    ], PasswordLogin.prototype, "onPersistentChanged", null);
    PasswordLogin = __decorate([
        Component({
            name: "PasswordLogin",
            components: {
                FormGroup: FormGroup,
                "b-row": Row,
                "b-col": Col
            }
        })
    ], PasswordLogin);
    return PasswordLogin;
}(Vue));
export default PasswordLogin;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Account/PasswordLogin.vue
// module id = 668
// module chunks = 24